import { useEffect } from 'react';

export const useDisableBodyScroll = (disabled) => {
  useEffect(() => {
    if (disabled) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [disabled]);
};
